var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import * as React from 'react';
import { SvgIcon } from '@mui/material';
function BookmarkIconInner(props) {
  return /*#__PURE__*/React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.04183 18.3654L10.5155 15.5693C11.3987 15.0173 12.6015 15.0174 13.4845 15.5693L18 18.3965V4.00001L6.00213 4L6.04183 18.3654ZM6.00213 2H17.9979C19.1036 2 20 2.89821 20 4.00001V20C20 21.1046 19.2402 21.5251 18.3034 20.9396L12.4245 17.2653C12.19 17.1188 11.8101 17.1187 11.5755 17.2653L5.69659 20.9396C4.75959 21.5253 4 21.1018 4 20V4.00001C4 2.89544 4.89451 2 6.00213 2Z",
    fill: ""
  }));
}
export var BookmarkIcon = function (props) {
  return /*#__PURE__*/React.createElement(SvgIcon, __assign({
    inheritViewBox: true,
    component: BookmarkIconInner
  }, props));
};